// extracted by mini-css-extract-plugin
export var filterIncDec = "_a3-0";
export var leftBorder = "_a3-1";
export var rightBorder = "_a3-2";
export var stringInput = "_a3-3";